import React from "react";
import { useApplicationStateValue } from "../application/Application";
import styled from "styled-components";
import { Flex, Box } from "reflexbox/styled-components";
import TitleSeparator from "../components/title-separator/TitleSeparator";
import { withLocalizeStrings } from "../languages/Localize";
import { NavLink } from "react-router-dom";
import routes from "../config/routes";

const StyledSpeakerContainer = styled(Flex)`
    flex-direction: row;
    border-bottom: 2px solid white;
`;

const StyledProfileImageContainer = styled(Box)`
    flex: 3;
    height: 100%;
`;

const StyledProfileImage = styled.img`
    object-fit: cover;
    object-position: top;
    height: 20vw;
    width: 20vw;
    border-radius: 15px;
`;

const StyledDataContainer = styled(Flex)`
    flex: 8;
    flex-direction: column;
    line-height: 15px;
`;

const StyledName = styled(Box)`
    width: 100%;
    font-weight: ${({ theme }) => theme.fontWeights.semiBold};
    color: ${({ theme }) => theme.colors.white};
`;

const StyledTitle = styled(StyledName)`
    font-weight: ${({ theme }) => theme.fontWeights.semiLight};
    font-style: italic;
`;

const StyledPanelsContainer = styled(Flex)`
    flex-wrap: wrap;
    justify-content: space-between;
`;

const StyledPanel = styled(Box)`
    display: inline-block;
    background: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.primary};
    border-radius: 3px;
    margin: 2px 0;
`;

const StyledLink = styled(NavLink)`
    display: block;
    width: 100%;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.white};
    &:hover,
    &:active {
        color: ${({ theme }) => theme.colors.white};
    }
`;

const SpeakersContainer = styled(Flex)`
    height: 93%;
    flex-direction: column;
    overflow: auto;
    flex: 1;
`;

const Speakers = ({ strings }) => {
    const {
        appData: { forumSpeakers, forumPanels }
    } = useApplicationStateValue();
    const speakers = Object.keys(forumSpeakers)
        .map(id => ({ id, ...forumSpeakers[id] }))
        .map(speaker => {
            let speakerPanels = [];
            speaker.panelsAsModerator?.forEach(id => {
                if (forumPanels[id]) {
                    speakerPanels.push(
                        <StyledPanel key={id} fontSize={[2]} padding={[1, 2]} marginRight={[1, 2]}>
                            {forumPanels[id].label}
                        </StyledPanel>
                    );
                }
            });
            speaker.panelsAsSpeaker.forEach(id => {
                if (forumPanels[id]) {
                    speakerPanels.push(
                        <StyledPanel key={id} fontSize={[2]} padding={[1, 2]} marginRight={[1, 2]}>
                            {forumPanels[id].label}
                        </StyledPanel>
                    );
                }
            });
            return (
                <StyledLink exact to={`${routes.SPEAKERS_DETAILS}${speaker.id}`} key={speaker.id}>
                    <StyledSpeakerContainer paddingX={[3, 4]}>
                        <StyledProfileImageContainer margin={[2, 3]} height={2}>
                            <StyledProfileImage src={speaker.imgUrl} alt="" />
                        </StyledProfileImageContainer>
                        <StyledDataContainer marginY={[2, 3]}>
                            <StyledName fontSize={[4]} lineHeight={[1.3]}>{speaker.name}</StyledName>
                            <StyledTitle fontSize={[3]} paddingBottom={[2]} paddingTop={[1.2]}>{speaker.title}</StyledTitle>
                            <StyledPanelsContainer>{speakerPanels}</StyledPanelsContainer>
                        </StyledDataContainer>
                    </StyledSpeakerContainer>
                </StyledLink>
            );
        });
    return (
        <Flex flexDirection="column" flex={1} height="100%">
            <TitleSeparator>{strings.speakers.HEADER}</TitleSeparator>
            <SpeakersContainer>{speakers}</SpeakersContainer>
        </Flex>
    );
};
export default withLocalizeStrings(Speakers);
